<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Period from '@/dc-it/models/Period'

export default {
  name: 'UsersView',
  components: { TableComponent },
  data() {
    return {
      model: Period,
    }
  },
}
</script>

<style scoped>

</style>
